import { AppBar, Box, Typography } from "@mui/material";
import React from "react";
import { observer } from "mobx-react-lite";
import Navbar from "../config/layout/Navbar";

const Slider = () => {
  return (
    <div className="home position-relative" id="home">
      {/* Navbar */}
      <AppBar position="static" className="navbTrans">
        <Navbar />
      </AppBar>

      {/* Carousel */}
      <div
        id="carouselExampleInterval"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {["slide3.jpg", "slide4.jpg", "slide5.jpg", "slide6.png"].map(
            (img, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                data-bs-interval="2000"
                key={img}
              >
                <img
                  src={require(`../assets/images/${img}`)}
                  className="d-block w-100 slider-img"
                  alt={`slide-${index}`}
                />
              </div>
            )
          )}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* Slide Text */}
      <Box
        className="slidebody"
        sx={{
          position: "absolute",
          top: { xs: "20%", sm: "30%" },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "90%", sm: "60%" },
          textAlign: "center",
          color: "#fff",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 1,
            fontSize: { xs: "1.2rem", sm: "2rem" },
          }}
        >
          Welcome To
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 1,
            fontSize: { xs: "1.5rem", sm: "2.5rem" },
          }}
        >
          মেসার্স কর্ণফুলী ইন্টারন্যাশনাল
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            mb: 1,
            fontSize: { xs: "1rem", sm: "1.8rem" },
          }}
        >
          M/S KARNAFULLY INTERNATIONAL
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontSize: { xs: "0.8rem", sm: "1.2rem" } }}
        >
          (Govt. Approved customs clearing & forwarding agent)
        </Typography>
      </Box>

      {/* CSS for carousel images */}
      <style>{`
        .slider-img {
          width: 100%;
          height: 60vh;
          object-fit: cover;
        }
        @media (max-width: 768px) {
          .slider-img {
            height: 40vh;
          }
        }
      `}</style>
    </div>
  );
};

export default observer(Slider);
